import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { Provider } from 'src/typings';
import { ProviderService } from '../provider.service';

@Component({
  selector: 'app-provider-create-dialog',
  templateUrl: './create-dialog.component.html',
  styleUrls: ['./create-dialog.component.scss']
})
export class ProviderCreateDialogComponent {
  saving = false;
  error = '';
  form = this.fb.group({
    description: [this.data?.description || '', [Validators.required, Validators.pattern(/\S/), Validators.maxLength(255)]],
    fullDescription: ['', Validators.maxLength(255)],
    taxNum: ['', Validators.maxLength(255)],
    orgNum: ['', Validators.maxLength(255)]
  });

  constructor(
    private fb: UntypedFormBuilder,
    private providers: ProviderService,
    private notifications: NotificationService,
    private dialogRef: MatDialogRef<ProviderCreateDialogComponent, Provider>,
    @Inject(MAT_DIALOG_DATA) public data: { description?: string }
  ) {}

  save() {
    if (this.saving) return;
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    const value = this.form.getRawValue();
    const payload = {
      description: value.description.trim(),
      fullDescription: value.fullDescription.trim(),
      taxNum: value.taxNum.trim(),
      orgNum: value.orgNum.trim()
    };
    this.saving = true;
    this.error = '';
    this.dialogRef.disableClose = true;
    this.form.disable({ emitEvent: false });
    this.providers.create(payload).subscribe({
      next: (provider) => {
        this.notifications.notice('Поставщик создан');
        this.dialogRef.close(provider);
      },
      error: (error) => {
        const message = error?.error?.message;
        this.error = typeof message === 'string' ? message : 'Не удалось создать поставщика. Попробуйте ещё раз.';
        this.saving = false;
        this.dialogRef.disableClose = false;
        this.form.enable({ emitEvent: false });
      }
    });
  }
}
